<script setup lang="ts"></script>

<template>
  <div class="w-full rounded-md border border-gray-200 bg-white p-6">
    <slot />
  </div>
</template>
